import formValidateMixin from "../mixins/form-validate";
import ModalMixin from "../mixins/modal";
import Axios from 'axios';
export default {
  name: "update-products-modal",
  props: ["title", "value", "user"],
  mixins: [formValidateMixin, ModalMixin],
  data: function data() {
    return {
      checkAll: false,
      // 是否全选
      indeterminate: false,
      // 是否半选
      products: [],
      data: {
        products: []
      },
      rules: {
        products: {
          type: "array",
          required: true
        }
      },
      loading: false
    };
  },
  methods: {
    onLoad: function onLoad() {
      var _this = this;
      if (this.user) {
        this.data.products.splice(0);
        this.user.productdetails.map(function (item) {
          _this.data.products.push(item.id);
        });
      }
      this.validate();
      Axios.get("fenxiang/product-details/?pagination=false").then(function (resp) {
        _this.products = resp.data['productdetails'];
        _this.getCheckAllStatus();
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;
      var data = this.data;
      this.loading = true;
      return Axios.put("users/".concat(this.user.id, "/productdetails/"), {
        productdetails: data.products
      }).then(function () {
        return _this2.loading = false;
      }, function (e) {
        _this2.loading = false;
        throw e;
      });
    },
    resetData: function resetData() {
      this.$refs.form.resetFields();
      this.data.products.length = 0;
      this.loading = false;
    },
    handleCheckChange: function handleCheckChange() {
      this.getCheckAllStatus();
      this.validate('products');
    },
    // 计算 全选、半选状态
    getCheckAllStatus: function getCheckAllStatus() {
      if (this.data.products.length === this.products.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (this.data.products.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
    },
    // 点击全选
    handleCheckAll: function handleCheckAll() {
      var _this3 = this;
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;
      if (this.checkAll) {
        this.data.products.splice(0);
        this.products.map(function (item) {
          _this3.data.products.push(item.id);
        });
      } else {
        this.data.products.splice(0);
      }

      // 没有触发change，手动校验
      this.validate();
    }
  }
};